export default __webpack_public_path__ + "static/logo-white-bec28841f6d6c4d5e7c78440a3063e09.svg";